import { useRoutes } from 'react-router-dom';
import { lazy } from 'react';
// project import
import LoginRoutes from './LoginRoutes';
import MainRoutes from './MainRoutes';
import Loadable from 'components/Loadable';
import InsideFifaRoutes from 'inside-fifa/routes/Routes';

// pages routing
export const NotFoundErrorPage = Loadable(lazy(() => import('pages/maintenance/404')));
export const UnauthorizedError = Loadable(lazy(() => import('pages/maintenance/401')));

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
    return useRoutes([
        LoginRoutes,
        MainRoutes,
        InsideFifaRoutes,
        {
            path: '*',
            element: <NotFoundErrorPage />,
        },
        {
            path: 'unauthorized',
            element: <UnauthorizedError />,
        },
    ]);
}
